{
  "collectionLabel": "Пропозиції"
}
